import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '../services/firebase';
import {
  isWebPaymentsEnabled,
  WEB_PAYMENTS_CONFIG_COLLECTION,
  WEB_PAYMENTS_CONFIG_DOCUMENT,
} from '../services/webPaymentsFeatureFlag';

export type WebPaymentsFeatureFlagState = {
  enabled: boolean;
  resolved: boolean;
};

export const useWebPaymentsFeatureFlag = (): WebPaymentsFeatureFlagState => {
  // Fail closed without presenting the disabled UI until Firestore resolves.
  const [state, setState] = useState<WebPaymentsFeatureFlagState>({ enabled: false, resolved: false });

  useEffect(() => onSnapshot(
    doc(firestore, WEB_PAYMENTS_CONFIG_COLLECTION, WEB_PAYMENTS_CONFIG_DOCUMENT),
    (snapshot) => setState({
      enabled: snapshot.exists() && isWebPaymentsEnabled(snapshot.data()),
      resolved: true,
    }),
    (error) => {
      console.error('Failed to load appConfig/feature_flags.webPaymentsEnabled:', error);
      setState({ enabled: false, resolved: true });
    },
  ), []);

  return state;
};

export const useWebPaymentsEnabled = (): boolean => useWebPaymentsFeatureFlag().enabled;
